import { Grid } from '@mui/material'
import React, { useEffect } from 'react'
import Cards from './Cards'
import ClickStatsChart from './ClickStatsChart'
import { useDispatch, useSelector } from 'react-redux'
import { getAffDashboard } from '../../../store/reducers/affiliateReducer'

const AffDashboard = () => {
    const dispatch = useDispatch();
    const dashboard = useSelector(state=>state.affiliate.dashboard)

    useEffect(()=>{
        dispatch(getAffDashboard())
    },[dispatch])

  return (
    <Grid container spacing={2}>
      <Grid container item xl={12}><Cards data={dashboard}/></Grid>
      <Grid item xs={12}><ClickStatsChart data={dashboard}/></Grid>
    </Grid>
  )
}

export default AffDashboard
